export default __webpack_public_path__ + "static/media/ProfilePhoto.0bc0de16.jpg";